<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-gear me-2"></i> Settings</h1>
  <p class="page-subtitle">Global key/value settings for application behaviour. Retention policy lives in <code>RETENTION_*</code> keys (XP, milestones JSON, leaderboard rules, social kill switches).</p>

  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
  @if (message) {
    <div class="alert alert-success">{{ message }}</div>
  }

  <div class="card">
    <div class="card-body">
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else if (rows.length === 0) {
        <p class="text-muted">No global settings found.</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 30%;">Key</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row.key) {
                <tr>
                  <td class="align-middle"><code>{{ row.key }}</code></td>
                  <td class="align-middle">
                    <input type="text" class="form-control" [(ngModel)]="row.editValue" [placeholder]="row.isNumeric ? 'Number' : 'Value'">
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="mt-3">
          <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
            @if (saving) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Save
          </button>
        </div>
      }
    </div>
  </div>
</div>
